import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";

const LABELS: Record<string, string> = { en: "English", zh: "繁體中文" };

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  return (
    <label className="inline-flex items-center gap-2">
      <span className="sr-only">{t("nav.language")}</span>
      <select
        className="rounded-full border border-hairline bg-surface px-3 py-1.5 text-sm font-bold text-ink focus:outline focus:outline-2 focus:outline-apricot"
        value={i18n.resolvedLanguage}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <option key={lng} value={lng}>
            {LABELS[lng]}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
